import React from "react";
import { OverlayTrigger, Popover } from "react-bootstrap";
import VideoLimitAlert from "~/components/shared/video_limit_alert";

const VideoLimitAlertChecker = ({
  showVideoLimitAlert, setShowVideoLimitAlert, placement = "top", children,
}) => {

  const renderPopover = (props) => (
    <Popover id="popover-doc-limit" {...props}>
      <Popover.Content className="bg-grey-lightest">
        <VideoLimitAlert onClose={() => setShowVideoLimitAlert(false)} />
      </Popover.Content>
    </Popover>
  );

  return (
    <OverlayTrigger
      placement={placement}
      overlay={renderPopover}
      trigger="manual"
      show={showVideoLimitAlert}
    >
      {children}
    </OverlayTrigger>
  );
};

export default VideoLimitAlertChecker;
